import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
    } catch (err) { /* réponse identique quoi qu'il arrive */ }
    setSent(true);
    setLoading(false);
  };

  return (
    <div className="lato-screen min-h-screen bg-[#FAF9F6] flex items-center justify-center px-6">
      <div className="w-full max-w-sm">
        <Link to="/login" className="inline-flex items-center text-gray-500 text-sm mb-8" data-testid="back-to-login">
          <ArrowLeft size={16} className="mr-1.5" /> Retour à la connexion
        </Link>
        <h1 className="text-2xl text-gray-800 mb-2">
          Mot de passe oublié
        </h1>
        {sent ? (
          <div className="mt-6 bg-[#FFFDF6] border border-[#F3EEE5] rounded-[20px] p-6 text-center" data-testid="forgot-success">
            <p className="text-sm text-gray-600 leading-relaxed">
              Si un compte existe avec cet email, un lien de réinitialisation vient d'être envoyé.
              <br /><br />Pense à vérifier tes spams.
            </p>
          </div>
        ) : (
          <>
            <p className="text-sm text-gray-500 font-light mb-8">
              Indique ton email, nous t'enverrons un lien pour choisir un nouveau mot de passe.
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="relative">
                <label htmlFor="forgot-email" className="sr-only">Email</label>
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-300" size={18} />
                <input
                  id="forgot-email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:border-[#F79AAE] transition-colors text-gray-700"
                  placeholder="ton@email.com"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full py-3 bg-[#F79AAE] text-white rounded-xl text-sm hover:bg-[#e8868d] transition-colors disabled:opacity-50"
                data-testid="forgot-submit-btn"
              >
                {loading ? 'Envoi…' : 'Envoyer le lien'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
